let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6bj2G")).then(() => parcelRequire('5R5iz'));